import { Box, Flex, FormLabel, Heading, Switch } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createBucketRequest,
  editBucketRequest,
} from "../../../../modules/superadmin-modules/bucket/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";

const AddBucket = ({ isAdd, data, setSelectedData }) => {
  const openChapter = useSelector((state) => state.model.isOpen11);
  const courses = useSelector((state) => state.courses.courses);
  const isLoading = useSelector((state) => state.superadminChapters.isLoading);

  const dispatch = useDispatch();

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const defaultCourse = {
    label: data?.course?.name,
    value: data?.course?.id,
  };
  useEffect(() => {
    if (openChapter) {
      dispatch(getAllCoursesRequest());
    }
  }, [openChapter]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة مجموعة" : "تعديل  مجموعة"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeCreateChapterModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      if (values.course_id) {
        await dispatch(createBucketRequest(values, action));
      } else {
        toast.error("اختر المادة");
      }
    } else {
      dispatch(
        editBucketRequest({
          id: data?.id,
          formData: values,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="الاسم "
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل  الاسم"
              register={register}
              name="name"
            />
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>المادة : </FormLabel>
              <Select
                options={coursesOptions}
                onChange={(data) => setValue("course_id", data.value)}
                styles={colourStyles}
                placeholder="المادة"
                defaultValue={defaultCourse}
              />
            </Box>
          </Box>
          <Box w="45%">
            <Box w="100%">
              <FormLabel>الحالة : </FormLabel>

              <Switch
                defaultChecked={data?.active}
                error={errors?.active?.message}
                {...register("active")}
                name="active"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddBucket;
